import GroupRadioItem from "./GroupRadioItem";
import GroupRadioRoot from "./GroupRadioRoot";

const GroupRadio = { Root: GroupRadioRoot, Item: GroupRadioItem };

export default GroupRadio;
